module.exports = __webpack_public_path__ + "static/img/2.b8359bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mgaofu/2.png
// module id = Nncf
// module chunks = 0